// extracted by css-extract-rspack-plugin
export default {"innerWrapper":"inner-wrapper--qWRwq6arkZQEwY8K"};